/**
 * Limit a variable's value to a range between a min and a max value.
 * @param value
 * @param min
 * @param max
 */
export function limitValueToMinMax(value: number, min: number, max: number) {
  return value > min ? (value < max ? value : max) : min;
}
